function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 6.0752,
    height: 14.504,
    fill: "none",
    viewBox: "0 0 6.0752 14.504",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m3.0384 14.504a.53493.53493 0 00.48633-.31055l2.5-5.4063a.53493.53493 0 00-.48633-.76172h-5a.53493.53493 0 00-.48633.76172l2.5 5.4063a.53493.53493 0 00.48633.31055z",
    style: {
      InkscapeStroke: "none",
      color: "#000000",
      fillRule: "evenodd",
      fill: "#b3b3b3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m3.0368 4.9858e-7a.53493.53493 0 00-.48633.31055l-2.5 5.4062a.53493.53493 0 00.48633.76172h5a.53493.53493 0 00.48633-.76172l-2.5-5.4062a.53493.53493 0 00-.48633-.31055z",
    style: {
      InkscapeStroke: "none",
      color: "#000000",
      fillRule: "evenodd",
      fill: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompass);
export default __webpack_public_path__ + "static/media/icon_compass.078e5b0dadedd97197b7a99f149a5d26.svg";
export { ForwardRef as ReactComponent };